<template lang="html">
  <v-select
    v-model="internalValue"
    :items="users"
    :label="label"
    v-bind="$attrs"
    single-line
    item-value="id"
    v-on="$listeners"
  >
    <template #selection="{ item, index, on }">
      <v-list-item
        :key="index"
        v-on="on"
      >
        <v-list-item-avatar
          class="my-0"
          size="36"
        >
          <v-img :src="item.details.profileImage" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.details.firstName }} {{ item.details.lastName }}</v-list-item-title>
          <!-- <v-list-item-subtitle v-if="item.subtext">{{item.subtext}}</v-list-item-subtitle> -->
        </v-list-item-content>
      </v-list-item>
    </template>
    <template #item="{ item, index, on }">
      <v-list-item
        :key="index"
        v-on="on"
      >
        <v-list-item-avatar>
          <v-img :src="item.details.profileImage" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.details.firstName }} {{ item.details.lastName }}</v-list-item-title>
          <!-- <v-list-item-subtitle v-if="item.subtext">{{item.subtext}}</v-list-item-subtitle> -->
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    value: String,
    label: {
      type: String,
      default: 'assignee'
    }
  },
  data () {
    return {
      internalValue: null
    }
  },
  computed: {
    ...mapGetters(['_users']),
    users () {
      return this._sortObject(this._users)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        this.internalValue = v
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
